<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query" :loading="meta.loading" title="检验" keywordPlaceholder="检验项目名称、床位号" hide-search-dialog>
    <template slot="search">
      <el-switch v-model="condition.ifSearchAllApply" active-text="全部" inactive-text="未打印" @change="query()" style="margin-right:1em"></el-switch>
      <el-date-picker type="daterange" v-model="meta.dateRange" size="small" range-separator="至" start-placeholder="申请开始日期" end-placeholder="申请结束日期" placeholder="申请日期" style="width: 270px" @change="dateChange" ></el-date-picker>
    </template>

    <el-table-column label="操作 " key="action" align="center" width="100">
      <template #default="{ row }">
        <el-button slot="reference" type="warning" size="mini" icon="el-icon-printer" circle plain title="打印" @click="print(row)" />
      </template>
    </el-table-column>
    <el-table-column label="已打印" prop="ifPrinted" key="ifPrinted" align="center" min-width="100" column-key="ifPrinted">
      <template slot-scope="{ row }">
        <el-tag v-if="row.state != '待接收'" type="success" size="small" hit effect="dark">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column v-if="condition.ifSearchAllApply" label="检验单号" prop="lisApplyNo" key="lisApplyNo" align="center" min-width="160"></el-table-column>
    <el-table-column label="床位号" prop="bedNo" key="bedNo" min-width="100"></el-table-column>
    <el-table-column label="患者姓名" prop="patientName" key="patientName" min-width="120"></el-table-column>
    <el-table-column label="性别" prop="patientGender" key="patientGender" align="center" min-width="80">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" key="patientAge" align="center" min-width="80"></el-table-column>
    <el-table-column label="检验项目" prop="detailContent" key="detailContent" min-width="300">
      <template slot-scope="{ row }">
        <el-tag type="primary" size="small" hit effect="plain">{{ row.detailContent }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="开嘱医生" prop="issuedDoctorName" key="issuedDoctorName" min-width="100"></el-table-column>
    <el-table-column label="申请时间" prop="issuedTime" key="issuedTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="执行护士" prop="execNurseName" key="execNurseName" min-width="100"></el-table-column>
  </hic-list-page>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  export default {
    data() {
      return {
        meta: {
          loading: false,
          dateRange: [],
        },
        condition: {
          ifSearchAllApply: false,
          pageSize: 20,
          pageIndexOnView: 1,
        },
        entities: {},
      }
    },
    computed: {
      ...mapGetters(["dictEnum", "user", "setting"]),
    },
    methods: {
      query() {
        this.meta.loading = true;
        api.LisRecord.queryApply(this.condition)
          .then((res) => {
            res.items.forEach(item => {
              item.detailContent = item.details.reduce((accumulator, currentValue, currentIndex) => {
                return accumulator + (accumulator ? '\n' : '') + (currentIndex + 1) + '. ' + currentValue.name;
              }, '');
            });
            this.$set(this, "entities", res);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      dateChange(v) {
        if (v) {
          if (Array.isArray(v)) {
            this.condition.issuedTimeStart = this.$utils.Fmt.startDatetime(v[0]);
            this.condition.issuedTimeEnd = this.$utils.Fmt.endDatetime(v[1]);
          } else {
            this.condition.issuedTimeStart = this.$utils.Fmt.startDatetime(v);
            this.condition.issuedTimeEnd = this.$utils.Fmt.endDatetime(v);
          }
        } else {
          this.condition.issuedTimeStart = null;
          this.condition.issuedTimeEnd = null;
        }
        this.query();
      },
      print(row) {
        window.location.href = 'HisCallLis://' + row.ipNo;
        row.state = '待检验';
      },
    }
  }
</script>
<style>
.el-tag {
  white-space: pre-wrap;
  height: auto;
}
</style>